export default "__VITE_ASSET__DdaXXy$H__"